<template>
  <div class="reading-comp">
    <div class="my-books container row">
      <div class="card" v-for="book in books" :key="book.id">
        <div class="card-content">
          <i class="material-icons delete" @click="deleteBook(book.id)">delete</i>
          <h2 class="red-text text-lighten-2">{{ book.title }}</h2>
          <p><span>Author</span> : {{ book. author }}</p>
          <div class="divider"></div>
          <p><span>Number of Pages</span> : {{ book.pages }}</p>
          <div class="divider"></div>
          <p><span>Genre</span> : {{ book.genre }}</p>
        </div>
        <span class="btn-floating btn-large halfway-fab red lighten-2 waves-effect waves-light">
          <router-link :to="{ name: 'EditBook', params: { book_slug: book.slug } }">
            <i class="material-icons edit">edit</i>
          </router-link>
        </span>
      </div>
    </div>
    <div>
      <a href="#" class="add-button btn-floating top btn-large red lighten-2 waves-effect waves-light pulse">
        <router-link :to="{ name: 'AddBook' }">
          <i class="material-icons">library_books</i>
        </router-link>
      </a>
    </div>
  </div>
</template>

<script>
// import the database (db = database)
import db from '@/firebase/init'

export default {
  data() {
    return {
      books: []
    }
  },
  methods:{
    deleteBook(id) {
      // delete doc from firestore
      // I get the id of the item when I click to delete it
      // then I will delete from firestore the doc with the same id
      db.collection('books').doc(id).delete()
      .then(() => {
        this.books = this.books.filter(book => {
          return book.id != id
        })
      })
    }
  },
  created() {
    // fetch data from the firestore
    // snapshot referes to the state of my collection at that current point in time
    // doc refers to the document
    db.collection('books').get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let book = doc.data()
          book.id = doc.id
          this.books.push(book)
      })
    })
  }
}
</script>

<style scoped>
.my-books {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 30px;
  margin-top: 60px;
}

.my-books h2 {
  font-size: 1.8em;
  text-align: center;
  margin-top: 0;
}

.my-books p {
  margin: 20px auto;
  text-align: center;
}

.my-books span {
  font-weight: bold;
}

.my-books .delete {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
  color: #aaa;
  font-size: 1.4em;
}

.add-button {
  position: fixed;
  bottom: 5px;
  left: 10px;
}
</style>
